<div class="content">
  <!-- Start Contenct-->
  <div class="container-fluid">
      
      <!-- DASHBOARD / SPORTS LIST -->
      <div class="row" *ngIf="!router.url.includes('inplay')">
          
          <div class="col-12 px-1">
            <!-- ======= desktop Slider ======= -->
            <section id="Slider" class="slider d-sm-block d-none" *ngIf="router.url.includes('dashboard')">
              <div id="Indexcarousel" class="carousel slide" data-ride="carousel" data-interval="2000">
                <div class="carousel-inner">
                  <div class="carousel-item" [ngClass]="{'active' : i==0}" *ngFor="let banner of env.host.desktopBannerList;let i=index">
                    <img class="d-block w-100" [src]="banner" alt="">
                  </div>
                </div>
              </div>
            </section>


            <section id="Slider" class="slider d-sm-none d-lock" *ngIf="router.url.includes('dashboard')">
              <div id="Indexcarousel" class="carousel slide" data-ride="carousel" data-interval="2000">
                <div class="carousel-inner">
                  <div class="carousel-item" [ngClass]="{'active' : i==0}" *ngFor="let banner of env.host.mobileBannerList;let i=index">
                    <img class="d-block w-100" [src]="banner" alt="">
                  </div>
                </div>
              </div>
            </section>
            <!-- ======= desktop Slider ======= -->
          </div>

          <!-- game start -->
          <div class="col-md-12 px-1" *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;">

            <!-- HOME PAGE -->
            <div class="horse" *ngIf="router.url.includes('dashboard')">
              <app-sport-list *ngIf="(events.sports.includes(mn.id))" [list]="homeData" [eventId]="mn.id"
                [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>
            </div>
            <!-- /HOME PAGE -->

            <!-- INPLAY PAGE -->
            <div class="horse" *ngIf="router.url.includes('inplay')">
              <app-sport-list *ngIf="(events.sports.includes(mn.id))" [list]="inPlayData" [eventId]="mn.id"
                [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>
            </div>
            <!-- /INPLAY PAGE -->

            <!-- SPORTS PAGE -->
            <div class="horse" *ngIf="router.url.includes('sports')">
              <app-sport-list *ngIf="(!events.casino.includes(mn.id))" [list]="data" [eventId]="mn.id"
                [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>
            </div>
            <!-- /SPORTS PAGE -->

            <!-- <app-casino *ngIf="tabId == mn.id && events.casino.includes(mn.id)" [eventId]="mn.id"
              [eventName]="mn.name"></app-casino> -->
            <!-- <app-casino *ngIf="tabId == mn.id && events.casino.includes(mn.id)" [gameId]="mn.id"></app-casino> -->

            <app-loader class="no-overlay" *ngIf="isLoad || !data"></app-loader>

          </div>
          <!-- game end -->

          
          <!-- New Hourse Upcomming Races Start -->
          <div class="col-md-12 px-1" *ngIf="router.url.includes('dashboard')">
            <div class="horse">
              <div class="sub_path">
                <p>Horse Racing</p>
              </div>
              <div class="game-wrap py-1 d-flex" *ngIf="hRaceList.length > 0">
                <span class="upcome">Coming Up</span>
                <div class="scroll-container indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                  <div style="white-space: nowrap;">
                    <ul class="horsedatahome">
                      <li *ngFor="let item of hRaceList;trackBy:trackByIndex;" [ngClass]="{'inplay-race' : raceInplyCheck(item)}">
                        <a href="javascript:void(0)" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                          <img src="https://speedcdn.io/assets/radheexch-client/icons/horse.svg" class="horsehomeimg" />
                          <!-- <img class="horsehomeimg" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png"> -->
                          <span class="mr-1">{{item?.market_start_time_format | date : 'hh:mm a'}}</span>
                          {{item?.event_name}} - {{item?.market_name}}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="game-wrap py-1 d-flex" *ngIf="hRaceList.length == 0">
                There is no upcoming hourse race.
              </div>
            </div>
          </div> <!-- New Hourse Upcomming Races End -->

          <!-- New Greyhound Upcomming Races Start -->
          <div class="col-md-12 px-1" *ngIf="router.url.includes('dashboard')">
            <div class="horse">
              <div class="sub_path">
                <p>Greyhound Racing</p>
              </div>
              <div class="game-wrap py-1 d-flex" *ngIf="gRaceList.length > 0">
                <span class="upcome">Coming Up</span>
                <div class="scroll-container indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                  <div style="white-space: nowrap;">
                    <ul class="horsedatahome">
                      <li *ngFor="let item of gRaceList;trackBy:trackByIndex;">
                        <a href="javascript:void(0)" routerLink="/event/detail/{{item?.event_id}}/{{item?.market_id}}">
                          <img src="https://speedcdn.io/assets/radheexch-client/icons/horse.svg" class="horsehomeimg" />
                          <!-- <img class="horsehomeimg" src="https://flagcdn.com/h40/{{item?.event_country_code.toLowerCase()}}.png"> -->
                          <span class="mr-1">{{item?.market_start_time_format | date : 'hh:mm a'}}</span>
                          {{item?.event_name}} - {{item?.market_name}}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="game-wrap py-1 d-flex" *ngIf="gRaceList.length == 0">
                There is no upcoming greyhound race.
              </div>
            </div>
          </div> <!-- New Greyhound Upcomming Races End -->

      </div>
      <!-- end row -->

      <!-- INPLAY -->
      <div class="row" *ngIf="router.url.includes('inplay')">
        <div class="col-lg-8 col-md-9 px-1">
            <div class="sub_path">
                <p>in-play</p>
            </div>
            <div class="inplayScreen">
                <div class="is_navTabs">
                  <!-- TABSET CODE -->
                  <tabset type="tabs nav-justified">
                    <ng-container *ngFor="let mn of menuItems; let i=index;trackBy:trackByIndex;">
                      <tab *ngIf="mn.id != 'multi' && mn.id != 'virtual_cricket'"  (selectTab)="onSelect(mn)">
                          <ng-template tabHeading>
                            <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/{{mn.id}}.png">
                            {{mn.name}}

                            <em class="event_count" *ngIf="mn.in_play_count > 0">{{mn.in_play_count}}</em>
                          </ng-template>


                          <div *ngIf="mn.name.includes('Watch')">

                            <!-- game start -->
                            <div *ngFor="let mn_inner of menuItems; let i=index;trackBy:trackByIndex;">
                              <!-- INPLAY PAGE -->
                                <app-sport-list *ngIf="(events.sports.includes(mn_inner.id))" [list]="inPlayData" [eventId]="mn_inner.id"
                                  [eventName]="mn_inner.name" [oddsData]="oddsLisDis"></app-sport-list>
                              
                              <!-- /INPLAY PAGE -->
                            </div>
                            <!-- game end -->
                          </div>
                          <div *ngIf="!mn.name.includes('Watch')">
                            <!-- sports and races -->
                            <app-sport-list *ngIf="tabId == mn.id && !events.casino.includes(mn.id)" [list]="data" [eventId]="mn.id" [eventName]="mn.name" [oddsData]="oddsLisDis"></app-sport-list>

                            <!-- casino -->
                            <app-casino *ngIf="tabId == mn.id && events.casino.includes(mn.id)" [casinoId]="mn.id"></app-casino>
                          </div>
                          
                      </tab>
                      <!-- tab virtual sports -->
                      <tab *ngIf="mn.id == 'virtual_cricket'">
                        <ng-template tabHeading>
                          <span [routerLink]="['/casino/99995']" [queryParams]="{ pId: 75, cId: 0}">
                          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/{{mn?.id}}.png">
                          {{mn?.name}}
                          </span>
                        </ng-template>
                      </tab>

                      <!-- tab multi market -->
                      <tab *ngIf="mn.id == 'multi'">
                        <ng-template tabHeading>
                          <span [routerLink]="['/event/multi-market']">
                          <img class="img-fluid" src="https://speedcdn.io/assets/radheexch-client/icons/market.svg">
                          {{mn?.name}}
                          </span>
                        </ng-template>
                      </tab>
                    </ng-container>
                    <app-loader class="no-overlay" *ngIf="isLoad"></app-loader>
                  </tabset>
                </div>
            </div>
        </div> <!-- end col-->
        <div class="col-lg-4 col-md-3 px-0 rightBar">
            <div class="matchBet">
                <p class="mt-0">matchhed bet</p>
                <app-bet-list *ngIf="isLogin()"></app-bet-list>
            </div>
        </div>

        
      </div>
    <!-- end row -->

  </div> <!-- container -->
</div> <!-- content -->